module.exports = __webpack_public_path__ + "static/media/Group13.79cf2135.svg";